import { BaseState } from '../types';

// Actions

export enum UploadTypes {
  UploadRequest = '@upload/REQUEST',
  UploadSuccess = '@upload/SUCCESS',
  UploadFailure = '@upload/FAILURE',
  UploadReset = '@upload/reset',
}

// Response

export interface UploadRequestPayload {
  date: string;
  file: File;
}

// State

export type UploadStatus = 'uploaded' | 'error' | 'waiting';

export interface UploadState extends BaseState {
  readonly isSuccess: boolean;
  readonly status: UploadStatus;
}
